import { useEffect } from 'react';
import { axios } from 'lib/axios';

export const useTrackVisitor = () => {
  useEffect(() => {
    // Prevent double tracking per day
    const lastTracked = localStorage.getItem('visitor_last_tracked');
    const today = new Date().toDateString();

    if (lastTracked === today) return; // already tracked today

    const trackVisitor = async () => {
      try {
        await axios.post('/visitor/track', {});
        localStorage.setItem('visitor_last_tracked', today);
      } catch (err) {
        console.error('Visitor tracking failed:', err);
      }
    };

    trackVisitor();
  }, []);
};
